import React, { FC, PropsWithChildren, createContext } from 'react';
import useMessages from 'hooks/useMessages';
import useUserData from 'FeatureModules/Auth/hooks/useUserData';
import { useMutation } from '@apollo/client';
import { ACCEPT_TERMS } from 'graphql/secure/mutations';
import DialogFormFrame from 'Components/Forms/DialogFormFrame';
import Loader from 'Components/Forms/Loader';
import TermsContent from 'FeatureModules/Auth/Components/TermsContent';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';

const TermsContext = createContext<null | boolean>(null);

const TermsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useUserData();

  const { setErrorMessage } = useMessages();

  const [updateTerms, { loading }] = useMutation(ACCEPT_TERMS, {
    variables: {
      input: {
        accepted: true,
      },
    },
    onError: () => {
      setErrorMessage('Sorry, something went wrong. Please try again later');
    },
  });

  if (!user) return <Loader />;

  return (
    <TermsContext.Provider value={user.latestTermsAccepted}>
      <DialogFormFrame
        open={false}
        onClose={() => null}
        title="Please accept our updated Terms and Conditions to further use our services"
        formComponent={<TermsContent />}
        actions={
          <ThemeButton loading={loading} color="PRIMARY" size="large" onClick={() => updateTerms()}>
            Accept
          </ThemeButton>
        }
      />
      {children}
    </TermsContext.Provider>
  );
};

export { TermsProvider };

export default TermsContext;
